import { Dispatch } from 'react'
import { generalOpenToastError, generalOpenToastInfo, generalOpenToastSuccess, generalOpenToastWarning, generalShowLoader } from '../general.actions'
import * as http from "../../api/http";
import { ENDPOINTS } from '../../api/config';
import { State } from '../../reducers';
import { ClienteF } from '../../interfaces/facturacion.interface';
import { KEYS } from '../../constants/keysStorage';
import { validarTipoDocumentoID } from '../../utils/validaciones';
import { unirChipsJoin } from '../../utils/strings.utils';
// *******************************************************************************************

export const buscarClienteReceptor = (formCliente: ClienteF) => async (dispatch: Dispatch<any>, getState: () => State) => {
  if(validarTipoDocumentoID(formCliente.tipoDocumento!, formCliente.numId!)) return null
  if (getState().general.loader) return null
  dispatch(generalShowLoader(true))

  const body = {
    opcion: 1,
    tipoDocumento: formCliente.tipoDocumento,
    numDocumento: formCliente.numId,
  }

  return await http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body, {}, KEYS.TOKEN)
  .then(async (res: any) => {
    if(res?.body !== null) {
      if (String(res?.body?.eliminado).toLowerCase() === 'true') {
        await dispatch(generalOpenToastInfo("El cliente es nuevo y será registrado al finalizar la factura, para llenarlo automáticamente en un nuevo documento.", "Aviso"))
        return null
      }
      if (String(res?.body?.activo).toLowerCase() !== 'true') { dispatch(generalOpenToastWarning('Este cliente se encuentra inactivo. Sus datos han sido cargados y puede continuar operando con normalidad.', 'Cliente inactivo')); }
      return res.body
    }
    await dispatch(generalOpenToastInfo("El cliente es nuevo y será registrado al finalizar la factura, para llenarlo automáticamente en un nuevo documento.", "Aviso"))
    return null;
  })
  .catch(async (err: any) => {
    let message = 'Se produjo un error al buscar la información del cliente.'
    await dispatch(generalOpenToastError(err?.response?.data?.message || message, "Alerta"))
    return null;
  })
  .finally(() => dispatch(generalShowLoader(false)))
}

export const guardarClienteReceptor = (formCliente: ClienteF, dispatch: Dispatch<any>) => {
  const body = {
    opcion: 2,
    tipoDocumento: formCliente.tipoDocumento,
    numDocumento:  formCliente.numId,
    nombre:  formCliente.nombre,
    direccion: formCliente.direccion,
    email: unirChipsJoin(formCliente.chipsEmail!, formCliente.email!),
    telefono:  formCliente.telefono,
    nrc:  formCliente.nrc || '',
    codActividad:  formCliente.actividad || '',
    descActividad:  formCliente.descripcion || '',
    departamento: formCliente.departamento,
    municipio: formCliente.municipio,
    ...(formCliente.distrito ? {distrito: formCliente.distrito} : {}),
    correocc: formCliente.correocc ?? '',
  }

  return http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body, {}, KEYS.TOKEN)
  .then((res: any) => {
    dispatch(generalOpenToastSuccess(res?.message || "Los datos del cliente han sido guardados satisfactoriamente."))
  })
  .catch((err: any) => {
    let message = 'Se produjo un error al guardar la información del cliente.'
    dispatch(generalOpenToastError(err?.response?.data?.message || message, "Alerta"))
  })
}